


























































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { getOutputType } from '@/services/transactions'
import { P, X } from '@/known_blockchains'
import {
    DEFAULT_NETWORK_ID,
    cChainExplorerURL,
    cChainExplorerURL_test,
} from '@/store/modules/network/network'
import { getTransactionChainType } from '@/js/Transaction'

@Component({
    filters: {
        getOutputType,
    },
})
export default class UtxoTxLinkOutput extends Vue {
    @Prop() txID!: string | null
    @Prop() chainID!: string
    @Prop() timestamp!: string

    get isXP(): boolean {
        return this.chainID === X.id || this.chainID === P.id
    }

    get xpURL(): string {
        return `/tx/${this.txID}`
    }

    get cURL(): string {
        return `${
            DEFAULT_NETWORK_ID === 1
                ? cChainExplorerURL
                : cChainExplorerURL_test
        }/tx/0x${this.txID}`
    }

    get chain(): string {
        return getTransactionChainType(this.chainID)?.name || ''
    }
}
